var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("InputNumber", {
    staticClass: "number-input",
    attrs: {
      value: _vm.value,
      max: _vm.max,
      min: _vm.min,
      precision: _vm.precision,
      "active-change": false,
      disabled: _vm.disabled,
      readonly: _vm.readonly,
    },
    on: { "on-change": _vm.onChange, "on-focus": _vm.onFocus },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }